const createDraggableChatIcon = () => {
  if (document.getElementById('fc-floating-icon')) return;

  const icon = document.createElement('div');
  icon.id = 'fc-floating-icon';

  const mobile = window.matchMedia('(max-width: 768px)').matches;
  const size = mobile ? 48 : 58;
  Object.assign(icon.style, {
    position: 'absolute',
    right: '24px',
    bottom: '24px',
    width: `${size}px`,
    height: `${size}px`,
    cursor: 'grab',
    zIndex: 999999999999999,
    userSelect: 'none',
    touchAction: 'none',
    background: '#04be76',
    borderRadius: '34px 8px 34px 34px',
    boxShadow: '0 8px 24px rgba(0,0,0,.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  const bubble = document.createElement('div');
  Object.assign(bubble.style, {
    width: '24px',
    height: '20px',
    background: '#fff',
    borderRadius: '6px 6px 6px 2px',
    position: 'relative',
  });

  const line1 = document.createElement('div');
  const line2 = document.createElement('div');

  [line1, line2].forEach((line, i) => {
    Object.assign(line.style, {
      height: '2px',
      background: '#04be76',
      borderRadius: '2px',
      margin: i === 0 ? '6px 4px 4px' : '0 4px',
      width: i === 0 ? '70%' : '50%',
    });
    bubble.appendChild(line);
  });

  icon.appendChild(bubble);
  document.body.appendChild(icon);

  // ===== DRAG =====
  let isDragging = false;
  let moved = false;
  let offsetX = 0;
  let offsetY = 0;

  icon.addEventListener('pointerdown', (e) => {
    isDragging = true;
    moved = false;
    offsetX = e.clientX - icon.offsetLeft;
    offsetY = e.clientY - icon.offsetTop;
    icon.setPointerCapture(e.pointerId);
  });

  icon.addEventListener('pointermove', (e) => {
    if (!isDragging) return;
    moved = true;

    const x = Math.min(
      window.innerWidth - icon.offsetWidth,
      Math.max(0, e.clientX - offsetX)
    );

    const y = Math.min(
      window.innerHeight - icon.offsetHeight,
      Math.max(0, e.clientY - offsetY)
    );

    icon.style.left = `${x}px`;
    icon.style.top = `${y}px`;
    icon.style.right = 'auto';
    icon.style.bottom = 'auto';
  });

  icon.addEventListener('pointerup', () => {
    isDragging = false;
  });

  icon.addEventListener('click', () => {
    if (moved) return;
    if (window.fcWidget) {
      if (window.fcWidget.isOpen()) {
        window.fcWidget.close();
      } else {
        window.fcWidget.open();
      }
    }
  });
};

export const WidgetChat = (auth) => {
  if (!document.getElementById('freshchat-script')) {
    const s = document.createElement('script');
    s.src = process.env.REACT_APP_FC_SRC;
    s.async = true;
    s.id = 'freshchat-script';
    s.setAttribute('chat', process.env.REACT_APP_FC_CHAT);
    s.setAttribute('widgetId', process.env.REACT_APP_FC_WIDGET_ID);

    document.body.appendChild(s);
  }

  const waitForWidget = () => {
    if (!window.fcWidget) {
      setTimeout(waitForWidget, 1000);
      return;
    }

    window.fcWidget.on('widget:loaded', () => {
      window.fcWidget.hide();
      if (!auth?.user?._id) return;
      if (auth?.user?.isAdmin) return;
      if (auth?.user?.roles?.supplierId || auth?.user?.corporateId) return;

      const isShowWidget = auth?.selectedFleet?.modules?.find(
        (permission) =>
          permission.name === 'Live Chat' && permission.key === 'Setting'
      );

      if (!isShowWidget) return;

      window.fcWidget.setExternalId(auth.user.userName);
      window.fcWidget.user.setFirstName(auth.user.firstName);
      window.fcWidget.user.setEmail(auth.user.email);
      window.fcWidget.user.setProperties({
        cf_fleet_name: auth?.selectedFleet?.name,
        cf_fleet_id: auth?.selectedFleet?.fleetId,
        cf_fleet_token: auth?.selectedFleet?.fleetToken,
        cf_subscription_plan: auth?.selectedFleet?.fleetBilling?.name,
        cf_status: auth?.selectedFleet?.fleetBilling?.subscription?.status,
      });

      createDraggableChatIcon();
      window.fcWidget.show();
    });
  };

  waitForWidget();
};

export const showWidgetChat = (auth) => {
  if (window.fcWidget) {
    if (window.fcWidget.isOpen()) {
      window.fcWidget.close();
    } else {
      window.fcWidget.open();
    }
  }
};
